import { trackingAction } from './itemsTrackingActions';
import * as Immutable from 'immutable';
import {Guid} from '../../../model/guid';

export type FinishedItems = Immutable.Set<Guid>;

export interface ItemsTrackingState {
  finishedItems: FinishedItems;
  trackedItems: Immutable.Set<string>;
}

export function createItemsTrackingReducer(startState: ItemsTrackingState) {
  return (state: ItemsTrackingState = startState, action: any): ItemsTrackingState => {
    switch (action.type) {
      case trackingAction.Tracking_ResetProgress:
      case trackingAction.Tracking_AddItem:
        return { ...state, finishedItems: action.payload };
      default:
        return state;
    }
  };
}
